import type { IconProps } from "@expo/vector-icons/build/createIconSet";
import type { ComponentProps } from "react";
import * as DropdownMenu from "zeego/dropdown-menu";
import { QendoIcon, type QendoIconSet } from "~/components/QendoIcon";
import { useTheme } from "~/providers/ThemeProvider";

type ItemIconProps = {
    icon: QendoIconSet;
    iconProps?: Omit<IconProps<QendoIconSet>, "name" | "size">;
    selected?: boolean;
} & ComponentProps<typeof DropdownMenu.ItemIcon>;

/**
 * @see https://hotpot.ai/free-icons for a reference of native icons
 */

export const DropdownItemIcon = DropdownMenu.create(
    ({ icon, children, iconProps, selected, ...itemIconProps }: ItemIconProps) => {
        const { colours } = useTheme();
        return (
            <DropdownMenu.ItemIcon {...itemIconProps}>
                {children ?? (
                    <QendoIcon
                        {...iconProps}
                        name={icon}
                        color={selected ? colours.icon.selected : colours.icon.primary}
                        size={20}
                    />
                )}
            </DropdownMenu.ItemIcon>
        );
    },
    "ItemIcon",
);
